/**
 * 全站維護模式
 * true = 所有路徑導向維護頁面
 */
export const MAINTENANCE_MODE = false;

/**
 * 功能開關設定
 * enabled: false = 完全關閉（不管登不登入）
 * requireAuth: true = 需要登入才能使用
 */
export const FEATURE_FLAGS = {
  DNA: { enabled: true, requireAuth: true }, // 護法DNA（需登入）
  QUIZ: { enabled: true, requireAuth: true }, // 中台知多少（需登入）
  POSTCARD: { enabled: true, requireAuth: true }, // 寄送明信片（需登入）
  LIVE_COMMENT: { enabled: true, requireAuth: false }, // 禪心連線
  JUE_GUANG: { enabled: true, requireAuth: true }, // 覺光庭影（會員互動影片區）
  TRANSMISSION: { enabled: true, requireAuth: false }, // 中台心傳
  PERSONA: { enabled: false, requireAuth: false }, // 人格測驗
  VIDEO_COLLECTION: { enabled: true, requireAuth: false }, // 影片集
  MEMBER_NOTIFICATION: { enabled: true }, // 首頁積分提醒 banner（未登入者）
  WISH_TREE: { enabled: true, requireAuth: true }, // 許願樹（需登入）
  GUARDIAN_EXPO: { enabled: true, requireAuth: false }, // 護博會
};

/**
 * @param {{ enabled: boolean, requireAuth: boolean }} flag
 * @param {boolean} isLoggedIn
 */
export const isFeatureAccessible = (flag, isLoggedIn = false) => {
  if (!flag.enabled) return false;
  if (flag.requireAuth && !isLoggedIn) return false;
  return true;
};
